<button (click)="setactivebutton(0)" [ngClass]="{ active: OrgTypeID === 0 }" type="button" class="dropdown">
  Over All</button>&nbsp;
<button [ngClass]="{ active: OrgTypeID === 6 }" type="button" class="dropdown ">
  {{ selectedCorporationName | titlecase }} &nbsp; <i class="arrow down"></i>
  <div class="dropdown-content">
    <ng-container>
      
        <div (click)="setCorporation(0, 'Smart City', 6,1)" class="sdivstyle">Smart City</div>
      <div (click)="setCorporation(0, 'Non Smart City', 6,0)" class="sdivstyle">Non Smart City</div>
      <div (click)="setCorporation(0, 'Overall Corporation', 6,2)" class="sdivstyle">Overall Corporation</div>
      <a *ngFor="let rl of smartcorporationList" (click)="setCorporation(rl.RegionID, rl.RegionName, 6,Smartflag)"><span
          *ngIf="rl.SmartCity">{{ rl.RegionName | titlecase }}</span></a>
      <a (click)="setCorporation(rl.RegionID, rl.RegionName, 6,Smartflag)" *ngFor="let rl of corporationList"><span
          *ngIf="!rl.SmartCity">{{ rl.RegionName | titlecase }}</span></a>
    </ng-container>
  </div>
</button>&nbsp;
<button [ngClass]="{ active: OrgTypeID === 8 }" type="button" class="dropdown">
  {{ selectedMunicipalityName | titlecase }} &nbsp; &nbsp;
  <i class="arrow down"></i>
  <div class="dropdown-content">
    <a (click)="setCorporation(rl.RegionID, rl.RegionName, 8,Smartflag)" *ngFor="let rl of regionList">{{ rl.RegionName
      | titlecase }}
    </a>
  </div>
</button>
&nbsp;
<button [ngClass]="{ active: OrgTypeID === 8 }" type="button" class="dropdown" *ngIf="showUlb">
  {{ selectedULBName | titlecase }} &nbsp; &nbsp;<i class="arrow down"></i>
  <div class="dropdown-content">
    <a *ngFor="let rl of ulbList" (click)="setULB(rl.MunicipalityID, rl.MuncipalityName)">{{ rl.MuncipalityName |
      titlecase }}
    </a>
  </div>
</button>